import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { ApprovalMethodDateModel } from './ApprovalMethodDateModel';
export var PendingAmendmentType = /*#__PURE__*/ function(PendingAmendmentType) {
    PendingAmendmentType["NetTerms"] = "netTermsChange";
    PendingAmendmentType["AmendmentsApprovalMethod"] = "approvalMethod";
    PendingAmendmentType["InvoicesApprovalMethod"] = "invoicesApprovalMethod";
    PendingAmendmentType["AllowManualPayments"] = "manualPaymentsChange";
    PendingAmendmentType["CoverCreditCardFees"] = "coverCreditCardFees";
    return PendingAmendmentType;
}({});
export class PendingAmendmentModel {
    static fromDTO(dto) {
        switch(dto.type){
            case "netTermsChange":
                return new PendingAmendmentNetTermsModel(dto);
            case "approvalMethod":
                return new PendingAmendmentAmendmentsApprovalMethodModel(dto);
            case "invoicesApprovalMethod":
                return new PendingAmendmentInvoicesApprovalMethodModel(dto);
            case "manualPaymentsChange":
                return new PendingAmendmentAllowManualPaymentsModel(dto);
            case "coverCreditCardFees":
                return new PendingAmendmentCoverCreditCardFeesModel(dto);
        }
    }
    toDTO() {
        return this.data;
    }
    isCoverCreditCardFees() {
        return this.data.type === "coverCreditCardFees";
    }
    isNetTerms() {
        return this.data.type === "netTermsChange";
    }
    isAmendmentsApprovalMethod() {
        return this.data.type === "approvalMethod";
    }
    isInvoicesApprovalMethod() {
        return this.data.type === "invoicesApprovalMethod";
    }
    isAllowManualPayments() {
        return this.data.type === "manualPaymentsChange";
    }
    approvalMethod() {
        return this.approvalMethodDateModel;
    }
    changedOn() {
        return this.data.value.changedOn;
    }
    constructor(data){
        _define_property(this, "data", void 0);
        _define_property(this, "approvalMethodDateModel", void 0);
        this.data = data;
        this.approvalMethodDateModel = ApprovalMethodDateModel.fromDTO(data.value.approvalMethod);
    }
}
export class PendingAmendmentNetTermsModel extends PendingAmendmentModel {
    value() {
        return this.netTermsDTO.value.value;
    }
    constructor(data){
        super(data), _define_property(this, "netTermsDTO", void 0);
        this.netTermsDTO = data;
    }
}
export class PendingAmendmentAmendmentsApprovalMethodModel extends PendingAmendmentModel {
    value() {
        return this.amendmentsApprovalMethodDTO.value.value;
    }
    constructor(data){
        super(data), _define_property(this, "amendmentsApprovalMethodDTO", void 0);
        this.amendmentsApprovalMethodDTO = data;
    }
}
export class PendingAmendmentInvoicesApprovalMethodModel extends PendingAmendmentModel {
    value() {
        return this.invoicesApprovalMethodDTO.value.value;
    }
    constructor(data){
        super(data), _define_property(this, "invoicesApprovalMethodDTO", void 0);
        this.invoicesApprovalMethodDTO = data;
    }
}
export class PendingAmendmentAllowManualPaymentsModel extends PendingAmendmentModel {
    value() {
        return this.allowManualPaymentsDTO.value.value;
    }
    constructor(data){
        super(data), _define_property(this, "allowManualPaymentsDTO", void 0);
        this.allowManualPaymentsDTO = data;
    }
}
export class PendingAmendmentCoverCreditCardFeesModel extends PendingAmendmentModel {
    value() {
        return this.coverCCFeesDTO.value.value;
    }
    constructor(data){
        super(data), _define_property(this, "coverCCFeesDTO", void 0);
        this.coverCCFeesDTO = data;
    }
}
